/**
 * Auslage-Berechnungslogik — Issue #584
 *
 * Reine Berechnungsfunktionen für die Erstattungs-Aufschlüsselung:
 * „Gutachten-Honorar X € + Werkstatt-Auslage Y € = Gesamt Z €"
 *
 * Keine React-Abhängigkeiten — direkt testbar mit Vitest.
 */

export interface ErstattungsAufschluesselung {
  honorar: number;
  auslage: number;
  gesamt: number;
}

/**
 * Berechnet die Erstattungs-Aufschlüsselung aus Gutachten-Honorar und
 * Werkstatt-Auslage. Gibt null zurück wenn beide Werte fehlen (kein
 * Erstattungsvorgang vorhanden).
 */
export function berechneErstattungsAufschluesselung(
  gutachtenHonorar: number | null | undefined,
  werkstattAuslage: number | null | undefined,
): ErstattungsAufschluesselung | null {
  const h = gutachtenHonorar ?? null;
  const a = werkstattAuslage ?? null;
  if (h === null && a === null) return null;
  const honorar = h ?? 0;
  const auslage = a ?? 0;
  return { honorar, auslage, gesamt: honorar + auslage };
}

/**
 * Formatiert die Aufschlüsselung als lesbaren deutschen String.
 * Beispiel: „Honorar 500,00 € + Auslage 300,00 € = Gesamt 800,00 €"
 */
export function formatErstattungsAufschluesselung(
  aufschluesselung: ErstattungsAufschluesselung,
): string {
  const fmt = (n: number) =>
    n.toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }) + ' €';
  return (
    `Honorar ${fmt(aufschluesselung.honorar)} ` +
    `+ Auslage ${fmt(aufschluesselung.auslage)} ` +
    `= Gesamt ${fmt(aufschluesselung.gesamt)}`
  );
}
